import React from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { useRootStore } from 'store/rootStore';
import SunLifeQuoteProposalInfoPage from './SunLife';
import DefaultQuoteProposalInfoPage from './Default';
import AlliedQuoteProposalInfoPage from './Allied';
import AltusQuoteProposalInfoPage from './Altus';
import DDNJQuoteProposalInfoPage from './DDNJ';
import DDIAQuoteProposalInfoPage from './DDIA';
import NEDDQuoteProposalInfoPage from './NEDD';
import DDWAQuoteProposalInfoPage from './DDWA';

function renderQuoteProposalInfoPage(sponsorId: string): React.ReactNode {
  switch (sponsorId) {
    case 'SUNLIFE':
      return <SunLifeQuoteProposalInfoPage />;
    case 'DDIC':
      return <AlliedQuoteProposalInfoPage />;
    case 'DDNJ':
      return <DDNJQuoteProposalInfoPage />;
    case 'DDWA':
      return <DDWAQuoteProposalInfoPage />;
    case '13':
      return <DDIAQuoteProposalInfoPage />;
    case '244':
      return <AltusQuoteProposalInfoPage />;
    case '122':
      return <NEDDQuoteProposalInfoPage />;
    default:
      return <DefaultQuoteProposalInfoPage />;
  }
}

const QuoteProposalInfoPage: React.FC = observer(() => {
  const { groupId } = useParams<{ groupId: string }>();
  const {
    domainStoreV2: { sponsorId },
  } = useRootStore();

  if (!groupId || !sponsorId) {
    return null;
  }

  return renderQuoteProposalInfoPage(sponsorId);
});

export default QuoteProposalInfoPage;
